import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BucketService, FileNode, FolderNode } from 'src/app/services/bucket/bucket.service';
import { BucketStoreService } from '../../bucket-store.service';
import { DialogInfoDocumentoComponent } from '../dialog-crea-cartella/dialog-info-documento/dialog-info-documento.component';

@Component({
  selector: 'app-menu-folder',
  standalone: false,

  templateUrl: './menu-folder.component.html',
  styleUrl: './menu-folder.component.scss',
})
export class MenuFolderComponent {
  private _folderSelezionato: FolderNode | undefined = undefined;

  @Input()
  get folderSelezionato(): FolderNode | undefined {
    return this._folderSelezionato;
  }

  set folderSelezionato(folderSelezionato: FolderNode | undefined) {
    this._folderSelezionato = folderSelezionato;
  }

  private _fileSelezionato: FileNode | undefined = undefined;

  @Input()
  get fileSelezionato(): FileNode | undefined {
    return this._fileSelezionato;
  }

  set fileSelezionato(fileSelezionato: FileNode | undefined) {
    this._fileSelezionato = fileSelezionato;
  }

  protected _isModulo: boolean = false;

  @Input()
  set isModulo(isModulo: boolean) {
    this._isModulo = isModulo;
  }

  get isModulo(): boolean {
    return this._isModulo;
  }

  @Input() isFolder: boolean = false;
  @Input() isFile: boolean = false;

  @Output() folderCreatoEvent: EventEmitter<boolean> = new EventEmitter();

  private readonly _store = inject(BucketStoreService);

  constructor(
    private readonly _bucketService: BucketService,
    private readonly _dialog: MatDialog,
  ) {}

  nuovoFolder(isCreazione: boolean) {
    const parentFolder = this.folderSelezionato;
    if (parentFolder) {
      this._store.creaFolder(parentFolder, isCreazione).subscribe((esito) => {
        if (esito?.id && isCreazione) {
          this.folderCreatoEvent.emit(true);
        }
      });
    }
  }

  deleteFolder() {
    const folder = this.folderSelezionato;
    if (folder) {
      this._store.eliminaFolder(folder);
    }
  }

  deleteFile() {
    const file = this.fileSelezionato;
    if (file) {
      this._store.eliminaFile(file);
    }
  }

  downloadFile() {
    const file = this.fileSelezionato;
    if (!file) {
      return;
    }

    this._bucketService.getDownloadFile(file.id).subscribe({
      next: (blob: Blob) => {
        if (!blob) {
          console.error('Blob non valido ricevuto dal server');
          return;
        }

        const fileName = file.name || 'downloaded-file';
        const url = globalThis.URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        globalThis.URL.revokeObjectURL(url);
      },
      error: (err) => console.error('Errore download:', err),
    });
  }

  renameFile() {
    const file = JSON.parse(JSON.stringify(this.fileSelezionato));
    if (file) {
      this._store.renameFile(file).subscribe((esito) => {
        console.log(esito);
      });
    }
  }

  public infoFileFolder() {
    const fileFolder = this.fileSelezionato ?? this.folderSelezionato;
    const dialogCreaFolder = this._dialog.open(DialogInfoDocumentoComponent, {
      data: { fileFolder: fileFolder },
      disableClose: false,
      width: '30%',
      height: 'auto',
      autoFocus: false,
    });

    return dialogCreaFolder.afterClosed().pipe();
  }

  /**
   * Importazione File
   */
  public async importaFile(files: FileList) {
    // Il browser ritorna un tipo FileList devo convertilo in array File per lavorarlo
    const filesArray: File[] = Array.from(files);
    await this._store.importaFile(filesArray, this.folderSelezionato);
  }
}
